module.exports = __webpack_public_path__ + "static/media/plus.f4adb7e4.svg";